import { makeEnvironmentProviders } from '@angular/core';
import { FoerchMsService } from '@services/ms/foerch-ms.service';
import { FoerchOccService } from '@services/occ/foerch-occ.service';
import { FoerchWebSocketService } from '@services/web-socket/foerch-web-socket.service';
import { FoerchAlertService } from '@services/foerch-alert.service';
import { FoerchDownloadService } from '@services/foerch-download.service';
import { FoerchGsmLocalStorageService } from '@services/foerch-gsm-local-storage.service';
import { FoerchNormalizeUrlPipe } from '@common/pipes/foerch-normalize-url.pipe';
import { FoerchGsmDisplayNamePipe } from '@common/pipes/foerch-gsm-display-name.pipe';

export function provideServices() {
  return makeEnvironmentProviders([
    FoerchAlertService,
    FoerchDownloadService,
    FoerchGsmDisplayNamePipe,
    FoerchGsmLocalStorageService,
    FoerchMsService,
    FoerchNormalizeUrlPipe,
    FoerchOccService,
    FoerchWebSocketService,
  ]);
}
